/** @jsxImportSource @emotion/react */

import React, { memo, useRef } from "react";
import { useIntl } from "react-intl";

import { Dialog, DialogContent, DialogProps } from "@material-ui/core";

import { Button, ViewState } from "..";
import config from "../../config";
import { useUser } from "../../context/user";
import usePlayerToken from "../../hooks/usePlayerToken";

import {
  dialog,
  dialogContent,
  readyDialogContent,
  video,
  backdrop,
  backButton,
  player as playerStyle,
  iframe,
} from "./styles";

interface Props extends DialogProps {
  src: string | undefined;
  onBackButtonClick: () => void;
  title?: string;
  native?: boolean;
}

const PreviewVideoDialog = (props: Props) => {
  const { src, onBackButtonClick, title, native = true, ...rest } = props;
  const { locale } = useUser();
  const intl = useIntl();
  const { player, getPlayerToken } = usePlayerToken();
  const iframeRef = useRef(null);

  const renderBackdropComponent = () => (
    <div css={backdrop}>
      <Button css={backButton} icon="arrow-left" onClick={onBackButtonClick}>
        {title}
      </Button>
    </div>
  );

  return (
    <Dialog css={dialog} BackdropComponent={renderBackdropComponent} disableEnforceFocus {...rest}>
      <DialogContent css={[dialogContent, (src || player.token) && readyDialogContent]}>
        {native ? (
          /* eslint-disable-next-line jsx-a11y/media-has-caption */
          <video key={src} controls width="600px" css={video}>
            <source src={src} type="video/mp4" />
            {intl.formatMessage({ id: "browser.not.support.video" })}
          </video>
        ) : (
          <div css={playerStyle}>
            <ViewState
              state={player.state}
              onClickRetry={(): void => {
                getPlayerToken();
              }}
            >
              <iframe
                css={iframe}
                src={`${config.PLAYER_URL}?t=${player.token}&hl=${locale}&preview=true`}
                title="Player"
                allow="autoplay; encrypted-media"
                allowFullScreen
                ref={iframeRef}
              />
            </ViewState>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default memo(PreviewVideoDialog);
